import { render, staticRenderFns } from "./PurchaseEditLedgersCard.vue?vue&type=template&id=21c11a32&scoped=true"
import script from "./PurchaseEditLedgersCard.vue?vue&type=script&lang=ts"
export * from "./PurchaseEditLedgersCard.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseEditLedgersCard.vue?vue&type=style&index=0&id=21c11a32&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c11a32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21c11a32')) {
      api.createRecord('21c11a32', component.options)
    } else {
      api.reload('21c11a32', component.options)
    }
    module.hot.accept("./PurchaseEditLedgersCard.vue?vue&type=template&id=21c11a32&scoped=true", function () {
      api.rerender('21c11a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseEditLedgersCard.vue"
export default component.exports